import { Path } from '@/main/router/routerPath';
import List from './List.vue';
import { CRUMB_LABEL_KEY, NAME } from './constants';

export const router = {
    path: NAME,
    name: NAME,
    component: List,
};
